import { render, staticRenderFns } from "./Module_circle.vue?vue&type=template&id=490c2651&style=height%3A100%25"
import script from "./Module_circle.vue?vue&type=script&lang=js"
export * from "./Module_circle.vue?vue&type=script&lang=js"
import style0 from "./Module_circle.vue?vue&type=style&index=0&id=490c2651&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports